import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { catchError, concatMap, map, mergeMap, switchMap, withLatestFrom } from "rxjs/operators";

import { KeepActions } from "../actions/keep.actions";
import { Store } from "@ngrx/store";
import { Job } from "src/app/public/keep/models/job.model";
import { Posting } from "src/app/public/keep/models/posting.model";

import { KeepService } from "src/app/public/keep/services/keep.service";


@Injectable()
export class KeepApiEffects{

    constructor(
        private keepService: KeepService,
        private actions$: Actions,
        private store: Store
    ){}
    
    addNewJob$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(KeepActions.jobNewSubmit),
            concatMap( (action) => {
                return this.keepService
                    .addNewJob (action.job)
                    .pipe( 
                        map( (result: Job) => { 
                            //if(carCriteria !== null)
                                return KeepActions.jobUpsertSuccess ( { job: result, objectSource: action.objectSource } );
                            })
                        )
            })
        )
    });

    addNewJobItem$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(KeepActions.jobItemNewSubmit),
            concatMap( (action) => {
                return this.keepService
                    .addNewJobItem (action.jobItem)
                    .pipe( 
                        map( (result: Job) => { 
                            //if(carCriteria !== null)
                                return KeepActions.jobUpsertSuccess ( { job: result, objectSource: action.objectSource } );
                            })
                        )
            })
        )
    });
    /*
    updateJob$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(KeepActions.jobUpdateSubmit),
            concatMap( (action) => {
                return this.keepService
                    .updateJob (action.job)
                    .pipe( 
                        map( (result: Job) => { 
                            
                                return KeepActions.jobUpsertSuccess ( { job: result, objectSource: action.objectSource } );
                            })
                        )
            })
        )
    });
    */

    executeJobAction$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(KeepActions.jobActionSubmit),
            concatMap( (action) => {
                return this.keepService
                    .executeJobAction (action.jobAction, action.job)
                    .pipe( 
                        map( (result: Job) => { 
                            
                                return KeepActions.jobUpsertSuccess ( { job: result, objectSource: action.objectSource } );
                            })
                        )
            })
        )
    });

    updateJobItem$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(KeepActions.jobItemUpdateSubmit),
            concatMap( (action) => {
                return this.keepService
                    .updateJobItem (action.jobItem)
                    .pipe( 
                        map( (result: Job) => { 
                            
                                return KeepActions.jobUpsertSuccess ( { job: result, objectSource: action.objectSource } );
                            })
                        )
            })
        )
    });

    deleteJobItem$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(KeepActions.jobItemDeleteSubmit),
            concatMap( (action) => {
                return this.keepService
                    .deleteJobItem (action.jobItemId)
                    .pipe( 
                        map( (result: Job) => { 
                            
                                return KeepActions.jobUpsertSuccess ( { job: result, objectSource: action.objectSource } );
                            })
                        )
            })
        )
    });

    updateJobStatus$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(KeepActions.jobStatusUpdateSubmit),
            concatMap( (action) => {
                return this.keepService
                    .updateJobStatus (action.jobId, action.status)
                    .pipe( 
                        map( (result: Job) => { 
                            
                                return KeepActions.jobUpsertSuccess ( { job: result, objectSource: action.objectSource } );
                            })
                        )
            })
        )
    });

    updateJobItemStatus$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(KeepActions.jobItemStatusUpdateSubmit),
            concatMap( (action) => {
                return this.keepService
                    .updateJobItemStatus (action.jobItemId, action.status)
                    .pipe( 
                        map( (result: Job) => { 
                            
                                return KeepActions.jobUpsertSuccess ( { job: result, objectSource: action.objectSource } );
                            })
                        )
            })
        )
    });



    updatePostingStatus$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(KeepActions.postingStatusUpdateSubmit),
            concatMap( (action) => {
                return this.keepService
                    .updatePostingStatus (action.postingId, action.status)
                    .pipe( 
                        map( (result: Posting) => { 
                            
                                return KeepActions.postingUpsertSuccess ( { posting: result, objectSource: action.objectSource } );
                            })
                        )
            })
        )
    });


    executePostingAction$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(KeepActions.postingActionSubmit),
            concatMap( (action) => {
                return this.keepService
                    .executePostingAction (action.postingAction, action.posting)
                    .pipe( 
                        map( (result: Posting) => { 
                            
                                return KeepActions.postingUpsertSuccess ( { posting: result, objectSource: action.objectSource } );
                            })
                        )
            })
        )
    });


}